/* eslint-disable no-unused-vars */
import {
  Button,
  Col,
  Divider,
  Modal,
  notification,
  Row,
  Typography,
} from "antd";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { URL_API, getToken } from "../../../../utils";
const ProfileMissionLevel = ({ partnerCode, ...props }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [claimCount, setClaimCount] = useState(0);
  const [claimedRewards, setClaimedRewards] = useState([]);

  const fetchData = () => {
    if (partnerCode) {
      axios({
        method: "GET",
        baseURL: URL_API,
        url: `/pos/member-profile/mission-level`,
        params: {
          partner_code: partnerCode,
        },
        headers: { Authorization: "Bearer " + getToken() },
      })
        .then((res) => {
          setData(res.data?.data);
          const claimCountFromAPI = res.data?.data?.claim_count;
          setClaimCount(claimCountFromAPI);
          if (claimCountFromAPI === 1 && claimedRewards.length === 0) {
            setClaimedRewards((prev) => (prev.length === 0 ? [1] : prev));
          } else if (claimCountFromAPI === 2) {
            setClaimedRewards([1, 2]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  useEffect(() => {
    fetchData();
  }, [partnerCode]);

  const handleClaimReward = async (rewardNumber) => {
    Modal.confirm({
      title: "ยืนยันการรับสิทธิ์",
      content: "คุณต้องการรับสิทธิ์นี้ใช่หรือไม่?",
      okText: "ตกลง",
      cancelText: "ยกเลิก",
      onOk: async () => {
        setLoading(true);
        try {
          const res = await axios({
            method: "POST",
            baseURL: URL_API,
            url: "/pos/member-profile/claim-mission-reward",
            data: {
              partner_code: partnerCode,
              data_mission: data?.data_mission,
            },
            headers: {
              Authorization: "Bearer " + getToken(),
            },
          });

          if (res.data.status === "already_claimed") {
            Modal.warning({
              title: "ผิดพลาด",
              content: "คุณเคยรับสิทธิ์ไปแล้ววันนี้",
              okText: "ตกลง",
            });
          } else {
            notification.success({
              message: "สำเร็จ",
              description: "คุณรับสิทธิ์เรียบร้อยแล้ว",
            });
            setClaimedRewards((prev) =>
              prev.includes(rewardNumber) ? prev : [...prev, rewardNumber]
            );
            fetchData();
          }
        } catch (error) {
          notification.error({
            message: "เกิดข้อผิดพลาด",
            description: "โปรดลองใหม่ภายหลัง",
          });
        } finally {
          setLoading(false);
        }
      },
    });
  };

  if (!data?.is_distributor || !data?.data_mission) return <div></div>;
  return (
    <>
      <Divider />
      <Row type="flex" align="middle" className="">
        <Col md={10}>
          <Typography.Title level={3} className="m-0 d-flex align-items-center">
            Mission Performance Level :{" "}
          </Typography.Title>
        </Col>
        <Col md={8}>
          <Typography.Title
            level={3}
            className="m-0 d-flex align-items-center font-weight-normal pt-1"
          >
            {data?.data_rank?.name}
          </Typography.Title>
        </Col>
        {data?.data_rank?.rank >= 1 && (
          <Col md={6}>
            <div className="d-flex align-items-center pt-1">
              {data?.is_have_maried ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <Button
                      type="primary"
                      disabled={claimedRewards.includes(1)}
                      onClick={() => handleClaimReward(1)}
                      className="m-0 d-flex align-items-center font-weight-normal "
                    >
                      {claimedRewards.includes(1)
                        ? "กดรับสิทธิ์แล้ว"
                        : "รับสิทธิ์"}
                    </Button>
                    <Button
                      type="primary"
                      disabled={claimedRewards.includes(2)}
                      onClick={() => handleClaimReward(2)}
                      className="m-0 d-flex align-items-center font-weight-normal "
                    >
                      {claimedRewards.includes(2)
                        ? "กดรับสิทธิ์แล้ว"
                        : "รับสิทธิ์"}
                    </Button>
                  </div>
                </>
              ) : (
                <Button
                  type="primary"
                  disabled={data.claim_count > 0}
                  onClick={() => handleClaimReward(1)}
                  className="m-0 d-flex align-items-center font-weight-normal"
                >
                  {claimedRewards.includes(1) ? "กดรับสิทธิ์แล้ว" : "รับสิทธิ์"}
                </Button>
              )}
            </div>
          </Col>
        )}
      </Row>
    </>
  );
};

export default ProfileMissionLevel;
